import { createContext, useContext, useState, useEffect } from 'react';
import api from '../utils/api';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('jsToken');
    const stored = localStorage.getItem('jsUser');
    if (token && stored) {
      setUser(JSON.parse(stored));
      setIsLoggedIn(true);
    }
    setLoading(false);
  }, []);

  // Called after signup/login — saves user to state + localStorage
  const login = (userData) => {
    setUser(userData);
    setIsLoggedIn(true);
    localStorage.setItem('jsUser', JSON.stringify(userData));
  };

  // POST /api/auth/signup
  const signup = async (name, email, phone, password, referralCode = '') => {
    const res = await api.post('/api/auth/signup', { name, email, phone, password, referralCode });
    const { token, user: userData } = res.data.data;
    localStorage.setItem('jsToken', token);
    login(userData);
    return res.data;
  };

  // POST /api/auth/login
  const loginWithEmail = async (email, password) => {
    const res = await api.post('/api/auth/login', { email, password });
    const { token, user: userData } = res.data.data;
    localStorage.setItem('jsToken', token);
    login(userData);
    return res.data;
  };

  const logout = async () => {
    try {
      await api.post('/api/auth/logout');
    } catch {}
    setUser(null);
    setIsLoggedIn(false);
    localStorage.removeItem('jsToken');
    localStorage.removeItem('jsUser');
  };

  const updateProfile = async (formData) => {
    const res = await api.put('/api/users/profile', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    const userData = res.data.data;
    setUser(userData);
    localStorage.setItem('jsUser', JSON.stringify(userData));
    return userData;
  };

  const addBusiness = async (formData) => {
    const res = await api.post('/api/businesses', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res.data;
  };

  const refreshUser = async () => {
    try {
      const res = await api.get('/api/auth/me');
      const userData = res.data.data;
      setUser(userData);
      localStorage.setItem('jsUser', JSON.stringify(userData));
    } catch {}
  };

  return (
    <AuthContext.Provider value={{ user, isLoggedIn, loading, login, signup, loginWithEmail, logout, updateProfile, addBusiness, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
